import Chip from '@mui/material/Chip'
import type { ChipProps } from '@mui/material/Chip'

interface TagPillProps extends Omit<ChipProps, 'label'> {
  label: string
  active?: boolean
}

export default function TagPill({ label, active, onClick, ...props }: TagPillProps) {
  return (
    <Chip
      label={label}
      onClick={onClick}
      size="small"
      variant={active ? 'filled' : 'outlined'}
      sx={{
        borderColor: active ? 'secondary.main' : 'rgba(138, 154, 91, 0.4)',
        backgroundColor: active ? 'secondary.main' : 'transparent',
        color: active ? '#ffffff' : 'primary.main',
        fontWeight: 600,
        fontSize: '0.78rem',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick
          ? {
              backgroundColor: active ? 'secondary.dark' : 'rgba(138, 154, 91, 0.12)',
            }
          : {},
        ...props.sx,
      }}
      {...props}
    />
  )
}
